import { render, staticRenderFns } from "./RsQuestionMatrix.vue?vue&type=template&id=67d555d8"
import script from "./RsQuestionMatrix.vue?vue&type=script&lang=js"
export * from "./RsQuestionMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports